/**
 * constants/routes.ts · 路由 path 常量
 *
 * 替代 v200/v300 散在各处的 magic string '#salesOrderList' 等
 *
 * 使用:
 *   import { Routes } from '@/constants/routes';
 *   navigate(Routes.QUOTATION_CREATE);
 *   <a href={Routes.HASH_PREFIX + Routes.GM_HOME}>...</a>
 */

export const Routes = {
  // ════ 系统 ════
  LOGIN: 'login',
  HELP_CENTER: 'helpCenter',
  NOTIFICATIONS: 'notifications',

  // ════ 13 *Home (角色化首页) ════
  GM_HOME: 'gmHome',
  SALES_HOME: 'salesHome',
  ENGINEER_HOME: 'engineerHome',
  PURCHASING_HOME: 'purchasingHome',
  WAREHOUSE_HOME: 'warehouseHome',           // WH-01 主管
  WAREHOUSE_RAW_HOME: 'warehouseRawHome',     // ⭐ WH-02/04 原料仓
  WAREHOUSE_FINISHED_HOME: 'warehouseFinishedHome', // ⭐ WH-03/05 成品仓
  PRODUCTION_HOME: 'supervisorHome',
  WORKER_HOME: 'workerHome',
  QUALITY_HOME: 'qualityHome',
  MAINT_HOME: 'maintHome',
  FINANCE_HOME: 'financeHome',
  HR_HOME: 'hrHome',
  GUARD_HOME: 'guardHome',
  ISO_HOME: 'isoHome',

  // ════ 销售部 ════
  QUOTATION_LIST: 'quotationList',
  QUOTATION_CREATE: 'quotationCreate',
  SALES_ORDER_LIST: 'salesOrderList',
  SALES_ORDER_CREATE: 'salesOrderCreate',
  ORDER_360: 'order360',
  CUSTOMER_LIST: 'customerList',
  CUSTOMER_CREATE: 'customerCreate',
  CUSTOMER_360: 'customer360',
  SALES_PIPELINE: 'mySalesPipeline',
  SALES_ANALYSIS: 'salesAnalysis',
  // ⭐ v363 合同模板系统
  CONTRACT_LIST: 'contractList',
  CONTRACT_CREATE: 'contractCreate',
  CONTRACT_DETAIL: 'contractDetail',
  CONTRACT_TEMPLATE_MANAGE: 'contractTemplateManage',

  // ════ 工程部 ════
  PRODUCT_LIST: 'productList',
  PRODUCT_CREATE: 'productCreate',
  PRODUCT_360: 'product360',
  BOM_TREE_EDITOR: 'bomTreeEditor',
  PROCESS_LIST: 'processList',
  PROCESS_COST_RATES: 'processCostRates',
  KIT_BOM_LIST: 'kitBomList',
  ALT_MATERIAL_LIST: 'altMaterialList',
  ARTWORK_REVIEW: 'artworkReviewQueue',

  // ════ 采购部 ════
  PR_LIST: 'prList',
  PR_CREATE: 'prCreate',
  PR_DETAIL: 'prDetail',
  PO_LIST: 'poList',
  PO_CREATE: 'poCreate',
  PO_DETAIL: 'poDetail',
  RFQ_LIST: 'rfqList',
  RFQ_CREATE: 'rfqCreate',
  SUPPLIER_LIST: 'supplierList',
  SUPPLIER_CREATE: 'supplierCreate',
  SUPPLIER_360: 'supplier360',
  SUPPLIER_SCORES: 'supplierScores',

  // ════ 仓储部 - 原料仓 ⭐ ════
  RAW_MATERIAL_LIST: 'rawMaterialList',
  RAW_MATERIAL_CREATE: 'rawMaterialCreate',
  AUXILIARY_LIST: 'auxiliaryList',
  AUXILIARY_CREATE: 'auxiliaryCreate',
  MATERIAL_COMBINATIONS: 'materialCombinations',
  RECEIVE_MATERIAL: 'receiveMaterial',
  RECEIPT_QR: 'receiptQR',
  ISSUE_MATERIAL: 'issueMaterial',
  MATERIAL_RECEIPTS: 'materialReceipts',
  MATERIAL_ISSUES: 'materialIssues',
  RAW_STOCK_TRANSFER: 'rawStockTransfer',
  MRP_CALC: 'mrpCalc',
  RAW_STOCK_ALERT: 'rawStockAlert',
  RAW_INVENTORY_ADJUST: 'rawInventoryAdjust',

  // ════ 仓储部 - 成品仓 ⭐ ════
  FINISHED_PRODUCT_LIST: 'finishedProductList',
  FINISHED_INBOUND: 'finishedInbound',
  FINISHED_OUTBOUND: 'finishedOutbound',
  SHIPPING_NOTE: 'shippingNote',
  SHIPPING_NOTE_DETAIL: 'shippingNoteDetail',
  DELIVERY_SCHEDULE: 'deliverySchedule',
  LOGISTICS_DISPATCH: 'logisticsDispatch',
  VEHICLE_MANAGE: 'vehicleManage',
  DRIVER_MANAGE: 'driverManage',
  FINISHED_STOCK_ALERT: 'finishedStockAlert',
  FINISHED_INVENTORY_ADJUST: 'finishedInventoryAdjust',

  // ════ 仓储部 - 跨原料+成品 ════
  INVENTORY_DASHBOARD: 'inventoryDashboard',
  INVENTORY_VALUE_REPORT: 'inventoryValueReport',
  INVENTORY_LIST: 'inventoryList', // 老路由兼容

  // ════ 生产部 ════
  SHORTAGE_LIST: 'shortageList',
  WO_MANAGE: 'woManage',
  WO_CREATE: 'woCreate',
  WO_DETAIL: 'woDetail',
  SCAN_START: 'scanStart',
  SCAN_REPORT: 'scanReport',
  GANTT_SCHEDULE: 'ganttSchedule',
  PRODUCTION_KANBAN: 'productionKanban',
  WORKSHOP_SCREEN: 'workshopScreen',
  OEE_CENTER: 'oeeCenter',
  TPM_CENTER: 'tpmCenter',

  // ════ 品控部 ════
  QC_RECORDS: 'qcRecords',
  QC_DETAIL: 'qcDetail',
  IQC_INCOMING: 'iqcIncoming',
  IPQC_INLINE: 'ipqcInline',
  OQC_OUTGOING: 'oqcOutgoing',
  QUALITY_GATE: 'qualityGate',
  QUALITY_CONTROL: 'qualityControl',
  COMPLAINTS_CENTER: 'complaintsCenter',
  COMPLAINT_CREATE: 'complaintCreate',
  COMPLAINT_DETAIL: 'complaintDetail',
  RETURNS_LIST: 'returnsList',
  RETURN_CREATE: 'returnCreate',

  // ════ 财务部 ════
  AR_INVOICE_LIST: 'arInvoiceList',
  AR_INVOICE_CREATE: 'arInvoiceCreate',
  AR_INVOICE_DETAIL: 'arInvoiceDetail',
  AP_INVOICE_LIST: 'apInvoiceList',
  AP_INVOICE_CREATE: 'apInvoiceCreate',
  AP_INVOICE_DETAIL: 'apInvoiceDetail',
  AR_AGING: 'arAging',
  AP_AGING: 'apAging',
  CUSTOMER_PAYMENTS: 'customerPayments',
  CUSTOMER_PAYMENT_CREATE: 'customerPaymentCreate',
  PAYMENT_DETAIL: 'paymentDetail',
  SUPPLIER_PAYMENTS: 'supplierPayments',
  PROFIT_LOSS: 'profitLoss',
  ORDER_PNL: 'orderPnl',                    // ⭐ v365 单订单损益
  ORDER_PNL_REPORT: 'orderPnlReport',       // ⭐ v365 期间损益报告
  MONTHLY_OVERHEAD: 'monthlyOverhead',
  VOUCHER_LIST: 'voucherList',
  BANK_RECONCILE: 'bankReconcile',
  EXPENSE_HUB: 'expenseHub',

  // ════ 人事部 ════
  EMPLOYEE_MANAGE: 'employeeManage',
  EMPLOYEE_CREATE: 'employeeCreate',
  HR_TIME_CENTER: 'hrTimeCenter',
  PAYROLL_CALC: 'payrollCalc',
  PAYROLL_CENTER: 'payrollCenter',
  LEAVE_REQUEST: 'leaveRequestList',
  OVERTIME_REQUEST: 'overtimeRequestList',
  TRAINING_RECORD: 'trainingRecordList',
  SOCIAL_INSURANCE: 'socialInsurance',
  HR_REPORTS: 'hrReports',

  // ════ 维修部 ════
  EQUIPMENT_LIST: 'equipmentList',
  EQUIPMENT_CREATE: 'equipmentCreate',
  MAINTENANCE_REQUEST: 'maintenanceRequest',
  MAINTENANCE_LOG: 'maintenanceLog',
  PM_SCHEDULE: 'pmSchedule',
  SPARE_PARTS_MANAGE: 'sparePartsManage',
  MAINT_CENTER: 'maintCenter',

  // ════ 行政 (保卫) ════
  GUARD_GATE_CONTROL: 'guardGateControl',
  GUARD_PATROL_DASHBOARD: 'guardPatrolDashboard',
  GUARD_PATROL_SCAN: 'guardPatrolScan',
  GUARD_STAMP_RECEIVE: 'guardStampReceive',
  GUARD_STAMP_DELIVERY: 'guardStampDelivery',
  GUARD_HISTORY: 'guardHistory',
  GUARD_PATROL_POINT_ADMIN: 'guardPatrolPointAdmin',

  // ════ ISO ════
  ISO_DOC_LIST: 'isoDocList',
  ISO_DOC_CREATE: 'isoDocCreate',
  ISO_DOC_VERSION: 'isoDocVersion',

  // ════ 跨部门报表 ════
  BOSS_COCKPIT: 'bossCockpit',
  DEPT_PERFORMANCE: 'deptPerformance',
  EMPLOYEE_EFFICIENCY: 'employeeEfficiency',
  SYSTEM_HEALTH: 'systemHealth',

  // ════ 工具 ════
  DATA_MIGRATION: 'dataMigration',
  FIELD_ACL_MANAGE: 'fieldAclManage',
  BACKUP_RESTORE: 'backupRestore',
  SYSTEM_LOG: 'systemLog',
} as const;

export type RouteValue = typeof Routes[keyof typeof Routes];

/** Hash 前缀 (hash-based router) */
export const HASH_PREFIX = '#';

/** 完整 href (用于 <a href>) */
export function hrefFor(route: RouteValue): string {
  return HASH_PREFIX + route;
}

/** 导航 helper */
export function navigateTo(route: RouteValue): void {
  window.location.hash = HASH_PREFIX + route;
}
